import styles from './ItemNumberTable.module.scss';
import { Trans } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { InfoCircle } from 'react-bootstrap-icons';
import calculationDescriptions from '../calculationDescriptions';

export default function ItemNumberTable({ item }) {
  const descriptionKey = item.calculationTypeId ? calculationDescriptions[item.calculationTypeId] : null;

  return (
    <>
      <div className={styles.itemContainer}>
        {item.displayName && item.displayName !== '' &&
          <div className={styles.header}>
            <b>{item.displayName}</b>
            {descriptionKey &&
              <OverlayTrigger
                placement="top"
                trigger={['hover', 'focus']}
                delay={{ show: 0, hide: 200 }}
                popperConfig={{ strategy: 'fixed' }}
                overlay={
                  <Tooltip className={styles.calcTooltip}>
                    <div className={styles.calcTooltipContent}>
                      <Trans i18nKey={descriptionKey} components={{ strong: <strong />, br: <br /> }} />
                    </div>
                  </Tooltip>
                }
              >
                <span className={styles.infoIconWrapper}>
                  <InfoCircle className={styles.infoIcon} size={12} />
                </span>
              </OverlayTrigger>
            }
          </div>}

        <div className={styles.textContainer}>
          <div className={styles.text}>{item.textValue}</div>
        </div>
      </div>
    </>
  );
}
